import { ModalDialog, Mtds } from 'prove-common'
import { buildTitle, CodeTypes } from '../../utils/codeValidation'
import { useCodeScan } from '../../hooks/useCodeScan'

type ModalProps = {
  type: CodeTypes
  onCodeScanned: (code: string, source: 'scan' | 'manual') => void
  setIsScanOpen: (open: boolean) => void
  isScanOpen?: boolean
}

export const CodeScanModal = ({
  type,
  onCodeScanned,
  setIsScanOpen,
  isScanOpen
}: ModalProps) => {
  const { scanner, manualEntry } = useCodeScan({
    type,
    onCodeScanned
  })

  return (
    <ModalDialog
      id='code-scan-modal'
      open={Boolean(isScanOpen)}
      onClose={() => setIsScanOpen(false)}
      className='h-screen w-screen'
    >
      <Mtds.Button
        command='close'
        commandfor={'code-scan-modal'}
        aria-label={'Lukk'}
      />
      <Mtds.Heading>{buildTitle(type)}</Mtds.Heading>
      {scanner}
      {manualEntry}
    </ModalDialog>
  )
}
